import React from 'react';
import PropTypes from 'prop-types';
import {ControlBlocksLoader as Loader} from './ControlBlock.loader';
import cname from '../AnimationSlider/style.module.scss';

export function ControlBlock(props) {
  return (
    <div className={cname.controlBlock}>
      {props.loading ? <Loader /> : props.children}
    </div>
  );
}

ControlBlock.propTypes = {
  /**
   * Boolean set to show loader
   */
  loading: PropTypes.bool,
  /**
   * List of child components
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};
